export default '2.45.2'
